import { useState, useEffect, useCallback } from 'react';
import { fetchStandings } from './api';
import PlayerStandings from './components/PlayerStandings';

export default function PublicStandingsApp() {
	const [standings, setStandings] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const load = useCallback(async () => {
		setLoading(true);
		setError(null);
		try {
			setStandings(await fetchStandings());
		} catch (err) {
			setError(err.message || 'Laden fehlgeschlagen.');
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		load();
	}, [load]);

	return (
		<PlayerStandings
			standings={standings}
			loading={loading}
			error={error}
			onRetry={load}
		/>
	);
}